import { get } from '../../../../infra/rest';
import requestConfig from '../../../../shared/config/request';
import { RecaptchaFallbackResponse } from '../typings';

const FALLBACK_API_ENDPOINT = requestConfig.smsServiceUrl + '/v1/sms/isWhitelisted';

export const getIsUserWhitelisted = async () => {
  return await get<RecaptchaFallbackResponse>(FALLBACK_API_ENDPOINT, {}, false, false, true);
};
